module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[117]604.be30fca.woff2";